import axios from "../plugins/axios";
const state = {
  doc_modal: false,
  type: null,
  o_id: null,
  main_task_id: 0,
  child_task_id: 0,
  loading: false,
  form_errors: [],
  item: {},
  form_data: {},
  items: [],
  doc_list_modal: false,
  form_name: null,
  bank_name: null,
  project_name: null,
  vendor_name: null,
  item_name: null,
  job_name: null,
  user_name: null,
  customer_name: null,
  doc_list_loading: false,
  doc_items: [],
  doc_types: [],
  report_names: [],
  refresh_doc_list: false,
  doc_module: null,
  doc_types_filter: [],
  doc_folder_filter: [],
  all_doc_type_list: [],
  doc_all: true,
  chart_of_account_name: null,
  module_item_list: [],
  is_from_dashboard: false,
  is_moved: false,
};
const getters = {
  getDataByKey: (state) => (key) => {
    return state[key];
  },
};
const actions = {
  getDocTypes({ commit, getters }, data) {
    axios
      .get(
        "get_doc_types?doc_module=" +
          getters.getDataByKey("doc_module") +
          "&is_filter=true&doc_all=" +
          getters.getDataByKey("doc_all") +
          "&f_o_id=" +
          getters.getDataByKey("o_id") +
          "&f_type=" +
          getters.getDataByKey("type") +
          "&main_task_id=" +
          getters.getDataByKey("main_task_id") +
          "&child_task_id=" +
          getters.getDataByKey("child_task_id") +
          "&" +
          data
      )
      .then(function(res) {
        commit("setDocumentData", {
          key: "doc_types",
          value: res.data.data,
        });
        commit("setDocumentData", {
          key: "doc_types_filter",
          value: res.data.data_filter,
        });
        commit("setDocumentData", {
          key: "doc_folder_filter",
          value: res.data.data_folder_filter,
        });
        commit("setDocumentData", {
          key: "all_doc_type_list",
          value: res.data.data_all,
        });
      });
  },
  getReportName({ commit, getters }) {
    axios
      .get("get_report_names?o_id=" + getters.getDataByKey("o_id"))
      .then(function(res) {
        commit("setDocumentData", {
          key: "report_names",
          value: res.data.data,
        });
      });
  },
  getModuleItemList({ commit, getters }, data) {
    axios
      .get(
        "get_module_item_list?doc_module=" +
          getters.getDataByKey("doc_module") +
          "&" +
          data
      )
      .then(function(res) {
        commit("setDocumentData", {
          key: "module_item_list",
          value: res.data.data,
        });
      });
  },
  async uploadFiles({ commit, getters }, data) {
    var formData = new FormData();
    formData.append("type", getters.getDataByKey("type"));
    formData.append("o_id", getters.getDataByKey("o_id"));
    formData.append("main_task_id", getters.getDataByKey("main_task_id"));
    formData.append("child_task_id", getters.getDataByKey("child_task_id"));

    let company_data = localStorage.getItem("company_data");
    company_data = JSON.parse(company_data);
    formData.append("company_id", company_data.company_id);

    if (data.is_dropbox) {
      formData.append("link", data.dropbox_file.link);
      formData.append("name", data.dropbox_file.name);
    }
    for (var key in data) {
      formData.append(key, data[key]);
    }

    commit("setDocumentData", { key: "doc_list_loading", value: true });
    commit("setDocumentData", { key: "form_errors", value: [] });
    await axios
      .post("document/add", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(function(res) {
        let data = res.data;
        if (!data.status) {
          // let errors = []
          // for(let key in data.errors){
          //   errors.push(data.errors[key][0])
          // }
          commit("setDocumentData", { key: "form_errors", value: data.errors });
        }
        if (data.status) {
          //if(getters.getDataByKey('type') == 1) {
          let item_data = getters.getDataByKey("item");
          item_data.docs_count = item_data.docs_count + 1;
          item_data.document_count = item_data.document_count + 1;
          item_data.document_for_parent_count =
            item_data.document_for_parent_count + 1;
          commit("setDocumentData", { key: "item", value: item_data });
          // } else if(getters.getDataByKey('type') == 7 || getters.getDataByKey('type') == 2) {
          //   let form_data = getters.getDataByKey('form_data')
          //   form_data.docs_count = form_data.docs_count + 1
          //   commit('setDocumentData',{key : 'form_data',value : form_data})
          // }
          //commit('setDocumentData',{key : 'doc_modal',value : false})
          //commit('setDocumentData',{key : 'type',value : null})
          //commit('setDocumentData',{key : 'o_id',value : null})
          commit("setDocumentData", { key: "form_errors", value: [] });
          commit("setDocumentData", { key: "form_data", value: [] });
        }
      })
      .catch(function() {})
      .then(function() {
        commit("setDocumentData", { key: "doc_list_loading", value: false });
      });
  },
  async moveFiles({ commit, getters }, data) {
    var formData = new FormData();
    formData.append("type", getters.getDataByKey("type"));
    formData.append("o_id", getters.getDataByKey("o_id"));
    formData.append("main_task_id", getters.getDataByKey("main_task_id"));
    formData.append("child_task_id", getters.getDataByKey("child_task_id"));

    let company_data = localStorage.getItem("company_data");
    company_data = JSON.parse(company_data);
    formData.append("company_id", company_data.company_id);

    if (data.is_dropbox) {
      formData.append("link", data.dropbox_file.link);
      formData.append("name", data.dropbox_file.name);
    }
    for (var key in data) {
      formData.append(key, data[key]);
    }

    commit("setDocumentData", { key: "doc_list_loading", value: true });
    commit("setDocumentData", { key: "form_errors", value: [] });
    await axios
      .post("document/move", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(function(res) {
        let data = res.data;
        if (!data.status) {
          commit("setDocumentData", { key: "is_moved", value: false });
          commit("setDocumentData", { key: "form_errors", value: data.errors });
          commit("setDocumentData", { key: "doc_list_loading", value: false });
        }
        if (data.status) {
          let item_data = getters.getDataByKey("item");
          item_data.docs_count = item_data.docs_count + 1;
          commit("setDocumentData", { key: "is_moved", value: true });
          commit("setDocumentData", { key: "item", value: item_data });
          commit("setDocumentData", { key: "form_errors", value: [] });
          commit("setDocumentData", { key: "form_data", value: [] });
          commit("setDocumentData", { key: "doc_list_loading", value: false });
        }
      })
      .catch(function() {
        commit("setDocumentData", { key: "doc_list_loading", value: false });
      });
  },
  getDocuments({ commit, getters }, data) {
    commit("setDocumentData", { key: "doc_list_loading", value: true });
    let type = getters.getDataByKey("type");
    let o_id = getters.getDataByKey("o_id");
    let main_task_id = getters.getDataByKey("main_task_id");
    let child_task_id = getters.getDataByKey("child_task_id");
    axios
      .get(
        "document/list?type=" +
          type +
          "&o_id=" +
          o_id +
          "&main_task_id=" +
          main_task_id +
          "&child_task_id=" +
          child_task_id +
          "&" +
          data
      )
      .then(function(res) {
        let data = res.data;
        commit("setDocumentData", { key: "doc_items", value: data.data });
        commit("setDocumentData", { key: "doc_list_loading", value: false });
      })
      .catch(function() {
        commit("setDocumentData", { key: "doc_list_loading", value: false });
      });
  },
};
const mutations = {
  setDocumentData(state, data) {
    state[data.key] = data.value;
  },
  setModal(state, data) {
    state.doc_modal = data;
    if (!data) {
      state.file_errors = [];
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
